import { EventTimestamp, PageAdditionalData } from '~/types/common';

type BaseItem = {
  relatedPageUid: string;
  id: string;
  url: string;
  title: string;
  description?: string;
  image?: any;
  label?: string | object;
  categories?: string | object;
  updatedAt?: string;
  pageAdditionalData?: PageAdditionalData;
  eventTimestamp?: EventTimestamp;
};

type NormalizedCardItem = {
  typeName: string;
  relatedPageUid: string;
  fullPath: string;
  pageAdditionalData: PageAdditionalData;
  eventTimestamp: EventTimestamp;
  heading: {
    headline: string;
    descriptionRte: string;
    detail: string;
    button: any[];
    link: any[];
    ui: any[];
  };
  image: {
    image: {
      url?: string;
      gatsbyImageData?: any;
    };
    alt: string;
    aspectRatio: string;
    objectFit: string | null;
    objectPosition: string;
    rounded: boolean;
    caption: string | null;
  };
  listingData: {
    label: any[];
    description: string;
  };
  categories: any[];
  updatedAt?: string;
};

function safeJSON<T = any>(val?: string | object): T | null {
  if (!val) return null;
  if (typeof val === 'object') return val as T;
  try {
    return JSON.parse(val as string);
  } catch {
    return null;
  }
}

export const normalizeItems = (data: BaseItem[]): NormalizedCardItem[] =>
  data.map((dataItem) => {
    const imageObj = safeJSON(dataItem.image);
    const categories = safeJSON(dataItem.categories) || [];

    return {
      typeName: 'RelatedAllItemsPageCard',
      updatedAt: dataItem.updatedAt,
      pageAdditionalData: { ...dataItem.pageAdditionalData },
      eventTimestamp: { ...dataItem.eventTimestamp },
      relatedPageUid: dataItem.relatedPageUid,
      fullPath: dataItem.url,
      heading: {
        headline: dataItem.title,
        descriptionRte: dataItem.description || '',
        detail: '',
        button: [],
        link: [],
        ui: [],
      },
      image: {
        image: {
          url: imageObj?.url || '',
          gatsbyImageData: imageObj?.data?.gatsbyImageData || null,
        },
        alt: 'Event Page Header',
        aspectRatio: '',
        objectFit: null,
        objectPosition: '',
        rounded: false,
        caption: null,
      },
      listingData: {
        label: [],
        description: dataItem.description || '',
      },
      categories: categories.map((cat: any) => ({
        title: cat.title,
        uid: cat.uid,
        urlDisplayName: cat.url_display_name ?? null,
        use_in_lables: cat.use_in_lables ?? null,
      })),
    };
  });
